import { FC, PropsWithChildren, useCallback, useState } from "react";

import { StrongAuthModalConfig, StrongAuthContext } from "../contexts/StrongAuthContext";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { StrongAuthModal } from "@/components/StrongAuthModal/StrongAuthModal";

export const StrongAuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<StrongAuthModalConfig | null>(null);

  const openStrongAuthModal = useCallback((modalConfig: StrongAuthModalConfig) => {
    setConfig(modalConfig);
    setIsOpen(true);
  }, []);

  const closeStrongAuthModal = useCallback(() => {
    setIsOpen(false);
    setConfig(null);
  }, []);

  return (
    <StrongAuthContext.Provider
      value={{
        isOpen,
        config,
        openStrongAuthModal,
        closeStrongAuthModal,
      }}
    >
      {children}
      {isOpen && config && <StrongAuthModal open={isOpen} onSubmit={config.onSubmit} onCancel={config.onCancel} />}
    </StrongAuthContext.Provider>
  );
};
